import { useMutation } from "@tanstack/react-query"
import { PostStoreSendQuizResultRequest } from "@repo/api-shared"
import { sendQuizResult } from "./server-action"

export function useSendQuizResult() {
    return useMutation({
        mutationFn: async (quizResultData: PostStoreSendQuizResultRequest) => {
            return await sendQuizResult(quizResultData)
        },
    })
}
